module.exports = __webpack_public_path__ + "img/15-half-sm.1e029521.jpg";